import {tokens} from '@pleo-io/telescope'
import styled from 'styled-components'

import ImageComponent from '@helios/shared/components/image'
import {colors} from '@helios/shared/theme'
import mq from '@helios/shared/utils/media-query'

import {Props} from './card'

export const Wrapper = styled.div<{hasImage: boolean}>`
    display: grid;
    gap: ${tokens.spacing20};
    padding: ${tokens.spacing20};
    background: ${colors.background.default};
    border-radius: ${tokens.arc8};
    grid-template-rows: ${(props) => (props.hasImage ? 'auto 1fr' : 'auto')};
`

interface ImageProps {
    $imageFit: Props['imageFit']
}

export const Image = styled(ImageComponent)<ImageProps>`
    width: 100%;
    height: auto;
    max-height: 140px;
    object-fit: ${(props) => props.$imageFit};

    ${mq.min('sm')} {
        max-height: 280px;
    }
`

export const Content = styled.div`
    display: grid;
    grid-template-rows: auto 1fr;
    gap: ${tokens.spacing10};
    justify-items: start;

    > *:last-child {
        align-self: end;
    }
`

export const TextWrapper = styled.div`
    display: grid;
    gap: ${tokens.spacing4};
`

export type TagProps = {
    $color: keyof typeof colors.tag
}

export const Tag = styled.div<TagProps>`
    padding: ${tokens.spacing4} ${tokens.spacing8};
    background: ${(props) => colors.tag[props.$color]};
    border-radius: ${tokens.arc4};
`

export const TagAndLink = styled.div`
    display: grid;
    row-gap: ${tokens.spacing24};
    justify-items: start;
`
